import { render } from "./PerkConfigsMembership.vue?vue&type=template&id=f1140680&scoped=true"
import script from "./PerkConfigsMembership.vue?vue&type=script&lang=js"
export * from "./PerkConfigsMembership.vue?vue&type=script&lang=js"

import "./PerkConfigsMembership.vue?vue&type=style&index=0&id=f1140680&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1140680"]])

export default __exports__